'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'minimize';
var width = 512;
var height = 512;
var aliases = ["compress-arrows-alt"];
var unicode = 'f78c';
var svgPathData = 'M204.2 50.47c-12-4.969-25.69-2.25-34.86 6.938L124.7 102.1l-81.39-81.39c-6.248-6.25-16.38-6.25-22.62 0c-6.248 6.246-6.248 16.38 0 22.62l81.39 81.38L57.39 169.4C51.27 175.5 48.02 183.7 48.02 191.1c0 4.125 .8125 8.312 2.453 12.28C55.45 216.3 67.05 224 80.03 224H192c17.67 0 32-14.33 32-32V80.03C224 67.03 216.2 55.44 204.2 50.47zM192 192H80.03l111.1-112c0 0 0-.0938 0 0L192 192zM320 224h111.1c13 0 24.59-7.766 29.56-19.77s2.25-25.69-6.938-34.86l-44.67-44.67l81.39-81.39c6.248-6.25 6.248-16.38 0-22.62c-6.248-6.25-16.38-6.25-22.62 0l-81.38 81.38L342.6 57.39c-6.156-6.125-14.28-9.375-22.59-9.375c-4.125 0-8.312 .8125-12.28 2.453C295.8 55.45 288 67.05 288 80.03V192C288 209.7 302.3 224 320 224zM320 80.03l112 111.1c0 0 .0938 0 0 0L320 192V80.03zM409.9 387.3l44.68-44.68c6.125-6.156 9.375-14.28 9.375-22.59c0-4.125-.8125-8.312-2.453-12.28C456.5 295.8 444.1 288 431.1 288H320c-17.67 0-32 14.33-32 32v111.1c0 13 7.766 24.59 19.77 29.56s25.69 2.25 34.86-6.938l44.67-44.67l81.39 81.39c6.248 6.25 16.38 6.25 22.62 0c6.248-6.246 6.248-16.38 0-22.62L409.9 387.3zM320 432C320 432 320 432.1 320 432L320 320h111.1L320 432zM192 288H80.03c-13 0-24.59 7.766-29.56 19.77s-2.25 25.69 6.938 34.86l44.67 44.67l-81.39 81.39c-6.248 6.25-6.248 16.38 0 22.62c6.248 6.25 16.38 6.25 22.62 0l81.38-81.38l44.68 44.68c6.156 6.125 14.28 9.375 22.59 9.375c4.125 0 8.312-.8125 12.28-2.453C216.3 456.5 224 444.1 224 431.1V320C224 302.3 209.7 288 192 288zM192 431.1l-112-111.1c0 0-.0938 0 0 0L192 320V431.1z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMinimize = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;